export enum Status {
    CREATED = -2,
    FAIL = -1,
    IN_PROGRESS = 0,
    SUCCESS = 1,
    VALIDATION_FAILED = 2,
}

export enum JobTypeCase {
    IMPORT = "IMPORT",
    EXPORT = "EXPORT",
    REPORT = "REPORT",
}

export enum EntityType {
    CLIENTS = "clients",
    EMPLOYEES = "employees",
    SERVICES = "services",
    SERVICE_CATEGORIES = "service-categories-new",
    IMPORT = "csvImportJob",
    EXPORT = "exportJob",
    REPORT = "reportJob",
}

export enum ImportEntityType {
    EMPLOYEE_TYPE = "employee",
    SERVICE_TYPE = "service",
    SERVICE_CATEGORY_TYPE = "serviceCategoryNew",
}

export enum bookingStatusIds {
    WAITING_FOR_CLIENT = 2,
    CLIENT_HAS_NOT_ARRIVED = 4,
    BOOKING_WAS_CANCELED = 5,
    COMPLETED = 6,
    COMPLETED_WITH_WAREHOUSE = 7,
}

export enum notificationRecordOption {
    DO_NOT_NOTIFY = 0,
    IN_30_MIN = 1,
    IN_1_HOUR = 2,
    IN_2_HOUR = 3,
    IN_3_HOUR = 4,
    IN_ONE_DAY = 5,
    IN_TWO_DAYS = 6,
}

export enum ThresholdMinutesForNotification {
    IN_30_MIN = 30,
    IN_1_HOUR = 60,
    IN_2_HOUR = 120,
    IN_3_HOUR = 180,
    IN_ONE_DAY = 1440,
    IN_TWO_DAYS = 2880,
}

export enum employeeWorkStatus {
    FIRED = 4,
}

export enum ActionUpdateType {
    Edit = "edit",
    Restore = "restore",
}

export enum GoogleTags {
    SCRIPT_ID = "google-tag-manager-script",
    ADSENSE_SCRIPT_ID = "google-adsense-script",
    GTM_ID = "GTM-W5LK2MNQ",
    ADSENSE_CLIENT_ID = "ca-pub-7056109210876208",
}

export enum ModulesTagName {
    BOOKING = "Online Booking",
    CLIENTS = "Clients",
    PERSONNEL = "Personnel",
    SERVICES = "Services",
    LOGBOOK = "Logbook",
    WAREHOUSES = "Warehouses",
    Menu = "Menu",
}

export enum SubModulesTagName {
    VISIT_HISTORY = "Visits History",
    SALARY = "Salary",
    SERVICE_PROVIDES = "Service providers",
    REVIEWS = "Reviews",
    STATISTIC = "Statistic",
}

export enum PaymentModulePeriod {
    YEARLY = "YEARLY",
    MONTHLY = "MONTHLY",
}

export enum AllModulesTagName {
    PERSONNEL = "Personnel",
    EMPLOYEES = "Employees",
    POSITIONS = "Positions",
    WORK_SCHEDULE = "Work Schedule",
    SALARY = "Salary",

    SERVICES = "Services",
    SERVICE_LIST = "Service List",
    SERVICE_CATEGORIES = "Service Categories",
    SERVICE_PROVIDES = "Service providers",

    CLIENTS = "Clients",
    CLIENT_LIST = "Client List",
    VISIT_HISTORY = "Visits History",

    LOGBOOK = "Logbook",
    STATISTIC = "Statistic",

    BOOKING = "Online Booking",
    REVIEWS = "Reviews",

    WAREHOUSES = "Warehouses",

    MENU = "Menu",
}

export enum TypesBusiness {
    BARBER_SHOP = "barber-shop",
}

export enum WarehouseTutorialType {
    WAREHOUSE_PRODUCT_MOVEMENT = "warehouseProductMovement",
    CONSUMABLES_WRITE_OFF = "consumablesWriteOff",
    PRODUCT_SALES = "productSales",
}

export enum BranchCategories {
    BARBER_SHOP = "barber-shop",
    RESTAURANT = "restaurant",
}

export enum CategoryPositionType {
    UP = "up",
    DOWN = "down",
}
